import { useState } from "react";
import "./TeamSection.css";

import person1 from "../../assets/perfiles/Director.jpeg";
import person2 from "../../assets/perfiles/roy.jpeg";
import person3 from "../../assets/perfiles/rebe.jpeg";

const members = [
    {
        id: 1,
        title: "CEO EMPRESA",
        image: person1,
    },
    {
        id: 2,
        title: "DIRECTOR OPERATIVO",
        image: person2,
    },
    {
        id: 3,
        title: "DIRECTORA GENERAL",
        image: person3,
    },
];

const TeamSection = () => {
    const [active, setActive] = useState(null);

    return (
        <section className="team">

            <h2>Nuestro Equipo</h2>

            <div className="cards">

                {members.map((member) => (
                    <div
                        key={member.id}
                        className={`card ${active === member.id ? "active" : ""}`}
                        onClick={() =>
                            setActive(active === member.id ? null : member.id)
                        }
                    >

                        <div className="image-container">
                            <img src={member.image} alt={member.title}/>
                        </div>

                        <div className="card-footer">
                            <h3>{member.title}</h3>
                        </div>

                    </div>
                ))}

            </div>

        </section>
    );
};

export default TeamSection;
